import React from "react";

const GHGDetails = () => {
  return (
    <div className=" grid grid-cols-2 max-[768px]:grid-cols-1 ">
      <div className=" border-r max-[768px]:border-none my-3">
        <div className=" p-5">
          <p className=" capitalize text-SH font-semibold text-ldarkblue ">
            EXEMPLAR GLOBAL Registration
          </p>
          <div className=" w-[250px] border border-darkblue mb-3" />

          <span>
            <ul class="list-none space-y-1 text-justify text-sm">
              <b>TVE International Academy</b> is an <b>EXEMPLAR GLOBAL</b>{" "}
              approved Training Organization. This GHG Accounting Lead
              Verifier/Lead Validator – <b>ISO 140642018</b> Training Course is
              registered by EXEMPLAR GLOBAL.
            </ul>
          </span>
        </div>

        <div className=" p-5">
          <p className=" capitalize text-SH font-semibold text-ldarkblue ">
            Who will benefit?
          </p>
          <div className=" w-[250px] border border-darkblue mb-3" />

          <span>
            <ul class="list-none space-y-1 text-justify text-sm">
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                Environmental Consultants looking to expand their skills in GHG
                emission quantification and verification, enabling them to offer
                GHG-related consulting services.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                Sustainability Managers seeking to better understand GHG
                reporting and verification, and to develop strategies for
                reducing emissions within their organizations.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                Regulatory Professionals tasked with monitoring and enforcing
                environmental standards, who need a thorough understanding of
                GHG accounting standards.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                Corporate Executives responsible for making decisions related to
                environmental compliance, sustainability, and carbon footprint
                management.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                Auditors and Compliance Officers aiming to conduct GHG
                verifications and support organizations in achieving compliance
                with international GHG standards.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                Project Managers working on environmental projects that require
                GHG quantification, monitoring, and reporting, particularly
                those managing emission reduction projects.
              </li>
            </ul>
          </span>
        </div>

        <div className=" p-5">
          <p className=" capitalize text-SH font-semibold text-ldarkblue ">
            Learning Objectives
          </p>

          <div className=" w-[250px] border border-darkblue mb-3" />
          <span>
            <ul class="list-none space-y-1 text-justify text-sm">
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                Understand the principles of ISO 14064 standards for GHG
                accounting and verification.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                Gain skills to quantify, report, and verify GHG emissions at
                organizational and project levels.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                Learn to apply emission factors and quantification methods for
                accurate GHG reporting.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                Develop the ability to verify GHG inventories and emission
                reduction projects.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                Be prepared to work as a Lead Verifier in GHG accounting.
              </li>
            </ul>
          </span>
        </div>

        <div className=" p-5">
          <p className=" capitalize text-SH font-semibold text-ldarkblue ">
            Course Format
          </p>
          <div className=" w-[250px] border border-darkblue mb-3" />

          <span>
            <ul class="list-none space-y-1 text-justify text-sm">
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                Course Program
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                Each day is divided into four sessions, two before lunch and two
                after lunch.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                The first session precedes the mid-morning break and the second
                follows mid-morning break.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                The afternoon sessions are similarly divided.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                The output of the exercise is a part of the formal continuous
                assessment and will therefore be marked.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                Although the exercises are group exercises individual score to
                the delegate will be based on their overall participation.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                A mock audit – Role play will be conducted on Days 3 & 4 of the
                Training for the delegates to demonstrate the skills learned and
                understood during the course. All sessions are interactive and
                delegate participation is encouraged.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                You will need to allow sufficient time to read and understand
                the notes which have been provided.
              </li>
            </ul>
          </span>
        </div>

       

        
      </div>

      <div className="  my-3">

         <div className=" p-5">
          <p className=" capitalize text-SH font-semibold text-ldarkblue ">
            Course Style
          </p>
          <div className=" w-[250px] border border-darkblue mb-3" />

          <span>
            <ul class="list-none space-y-1 text-justify text-sm">
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                All sessions are delegate interactive and delegate participation
                is encouraged. Delivery will include presentations by lecture,
                overhead and slide projection.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                There are numerous exercises and each activity is assessed as
                part of the overall candidature evaluation.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                A model factory will be used and wherever possible practical
                illustrations will be given.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                A live audit in a host organization (or an audit role play) will
                take place on day 4 so as the delegates may demonstrates the
                skills learned and developed during the course.
              </li>
            </ul>
          </span>
        </div>
        <div className=" p-5">
          <p className=" capitalize text-SH font-semibold text-ldarkblue ">
            Expected Prior knowledge
          </p>
          <div className=" w-[250px] border border-darkblue mb-3" />

          <span>
            <ul class="list-none space-y-1 text-justify text-sm">
              {/* <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
               Familiarity with ISO 14064 standards (1, 2, and 3) and their applications in GHG accounting.
              </li> */}
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                Basic understanding of greenhouse gas emissions and their impact
                on the environment.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                Knowledge of GHG emission sources, sinks, and the importance of
                quantifying and reporting emissions.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                Awareness of emission factors and how they are used in GHG
                quantification.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                Familiarity with reporting boundaries and the concepts of direct
                and indirect emissions.
              </li>
            </ul>
          </span>
        </div>
        <div className=" p-5">
          <p className=" capitalize text-SH font-semibold text-ldarkblue ">
            Highlights
          </p>
          <div className=" w-[250px] border border-darkblue mb-3" />

          <span>
            <ul class="list-none space-y-1 text-justify text-sm">
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                Training Programs are handled by Highly Experienced and EXEMPLAR
                GLOBAL Qualified Lead Verifier.
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                The Batches once committed will not be cancelled
              </li>
              {/* <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                3 Fully Equipped Training Halls available at Trichy to carry out Multi Program at the
same time
              </li> */}
            </ul>
          </span>
        </div>

        <div className=" p-5">
          <p className=" capitalize text-SH font-semibold text-ldarkblue ">
            Course Period
          </p>
          <div className=" w-[250px] border border-darkblue mb-3" />

          <span>
            <ul class="list-none space-y-1 text-justify text-sm">
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                Virtual Training – 4 days - Learning delivered in Virtual Platform like Zoom/Adobe connect
              </li>
              <li class="flex items-start">
                <span class="before:content-['•'] before:mr-1 before:text-black"></span>
                Self-Study – 4 days - Learning where the learner studies remotely using Course Materials sent by TVE and
communicates with the Tutor electronically via email / audio / visual conference etc..
              </li>
             
            </ul>
          </span>
        </div>
      </div>
    </div>
  );
};

export default GHGDetails;
